"use strict";

spreadsheets.service("SpreadsheetsService", function(SpreadsheetModelService, authServiceFactory) {

    this.fields = {};
    this.fields.combined = {};
    this.fields.familyOne = {};
    this.fields.familyTwo = {};
    this.fields.awardData = {};
    this.fields.ssq = {};
    this.fields.budgets = {};
    this.fields.applicant = {};
    this._id = null;
    this._type = null;
    this._list = null;
    this._name = null;
    this.item = undefined;

    this.dirty = false;

    this.setDirty = function(bool) {
        this.dirty = bool;
    };

    this.resetSpreadsheet = function() {
        this.fields = {};
        this.fields.combined = {};
        this.fields.familyOne = {};
        this.fields.familyTwo = {};
        this.fields.awardData = {};
        this.fields.ssq = {};
        this.fields.budgets = {};
        this.fields.applicant = {};
        this._id = null;
        this._type = null;
        this._list = null;
        this._name = null;
    };

    this.getName = function() { return this._name; };
    this.setName = function(name) {
        this._name = name;
        this.dirty = true;
    };

    this.getList = function() { return this._list; };
    this.setList = function(list)
    {
        for(var i = 0; i < list.length; i++)
        {
            this._id = list[i].recordID;
            this.fields.combined[list[i].column] = true;
            this.fields.familyOne[list[i].column] = true;
            this.fields.familyTwo[list[i].column] = true;
            this.fields.awardData[list[i].column] = true;
            this.fields.ssq[list[i].column] = true;
            this.fields.budgets[list[i].column] = true;
            this.fields.applicant[list[i].column] = true;
        }

        this._list = list;
        this.dirty = true;
    };

    this.addRemove = function(choice, add)
    {
        if (this._list == undefined)
            this.setList([]);
        if (choice.column)
            choice.code = choice.column;

        this.fields.combined[choice.code] = add;
        this.fields.familyOne[choice.code] = add;
        this.fields.familyTwo[choice.code] = add;
        this.fields.awardData[choice.code] = add;
        this.fields.ssq[choice.code] = add;
        this.fields.budgets[choice.code] = add;
        this.fields.applicant[choice.code] = add;

        if (add == false || add == undefined)
        {
            for (var i = 0; i < this._list.length; i++) {
                if (this._list[i].column == choice.code)
                    this._list.splice(i, 1);
            }
        }
        else {
            this._list.push({column: choice.code, title: choice.title, order: this._list.length - 1, spreadsheetID: this._id});
        }

        for (let i = 0; i < this._list.length; i++) {
            this._list[i].order = i;
        }

        this.dirty = true;
    };

    this.getItems = function()
    {
        return SpreadsheetModelService.get(authServiceFactory.getAuth().schoolID);
    }

    this.newItem = function(list)
    {
        if (this.item==undefined) {
            this.item = list;
        }

        return this.item;
    }

    return this;

});
